var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dp-container',{staticClass:"dp-route-error"},[_c('span',[_vm._v("Please check your internet connection and try again.")]),_c('dp-button',{attrs:{"icon":"refresh","size":"small"},on:{"click":_vm.reloadRoute}},[_vm._v(" Reload ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }